(function () {
  'use strict';

  function readConfig() {
    var el = document.getElementById('academy-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function showError(message, onRetry) {
    var app = document.getElementById('app');
    if (!app) return;
    app.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'wrap';
    wrap.style.padding = '40px 20px';
    wrap.style.color = '#4B5B70';
    var text = document.createElement('p');
    text.textContent = message;
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = 'Retry';
    retry.addEventListener('click', onRetry);
    wrap.appendChild(text);
    wrap.appendChild(retry);
    app.appendChild(wrap);
  }

  function loadAppScript(src, onLoad, onError) {
    if (document.getElementById('academy-app-script')) {
      onLoad();
      return;
    }
    var script = document.createElement('script');
    script.id = 'academy-app-script';
    script.src = src;
    script.onload = onLoad;
    script.onerror = onError;
    document.body.appendChild(script);
  }

  function boot() {
    var config = readConfig();
    if (!config || !config.catalogUrl || !config.appScriptUrl) {
      showError('Academy configuration is missing or invalid.', boot);
      return;
    }

    window.__ASSETS = config.assetBase || 'assets/';

    fetch(config.catalogUrl, { cache: 'force-cache' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (catalog) {
        window.__CONTENT = catalog;
        // Snapshot signup counters are an audit artifact, not live demand;
        // leaving __SIGNUPS unset makes count() in the app's own code
        // return 0 instead of fabricated numbers.
        window.__SIGNUPS = null;
        loadAppScript(
          config.appScriptUrl,
          function () {},
          function () { showError('Could not load the Academy application. Please try again.', boot); }
        );
      })
      .catch(function () {
        showError('Could not load the Academy catalogue. Please check your connection and try again.', boot);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
